import { getConfiguration } from '@chr/common-web-ui-configuration';
import { getAxiosInstance } from '@chr/online-shared-microsite-core';
import { AppConfig } from 'react-app-env';
import { NoContentResult, UserWidgets } from '../constants/online.homepagegateway.api';

export const getUserWidgets = async (): Promise<UserWidgets> =>{
  const axiosInstance = await getAxiosInstance();
  const config = await getConfiguration<AppConfig>();
  const serviceUrl = config.gatewayApiUri;

  const response = await axiosInstance.get<UserWidgets>(`${serviceUrl}/users/widgets`);
  return response.data;
}

export const updateUserWidgets = async (userWidgets: UserWidgets): Promise<NoContentResult> =>{
  const axiosInstance = await getAxiosInstance();
  const config = await getConfiguration<AppConfig>();
  const serviceUrl = config.gatewayApiUri;

  return await axiosInstance.put<NoContentResult>(`${serviceUrl}/users/widgets`, userWidgets);
}